/**
 * Black Hype Progress Bar
 * Monitors and updates the cart progress bar for promotions
 */

(function () {
    'use strict';

    // Configuration
    const TIERS = [
        { needed: 2, free: 1, message: 'Compre 1 Leve 2' },
        { needed: 4, free: 2, message: 'Pague 2 Leve 4' },
        { needed: 6, free: 3, message: 'Pague 3 Leve 6' }
    ];

    const MAX_TIER_NEEDED = TIERS[TIERS.length - 1].needed;
    let updateTimeout = null;
    let isUpdating = false;

    /**
     * Update progress bar with cart data
     */
    function updateProgressBar() {
        // Check if progress bar exists in DOM
        const fillEl = document.getElementById('progress-bar');
        const textTopEl = document.getElementById('progress-text-top');
        const textBottomEl = document.getElementById('progress-text-bottom');
        const markers = document.querySelectorAll('.shipping-bar__marker');

        if (!fillEl || !textTopEl || !textBottomEl || !markers.length) {
            return;
        }

        // Prevent multiple simultaneous updates
        if (isUpdating) return;
        isUpdating = true;

        // Fetch cart data with cache busting
        fetch('/cart.js?v=' + Date.now())
            .then(r => r.json())
            .then(cart => {
                // Count only real products (exclude patches)
                let count = 0;
                ('🛒 [Black Hype] Checking cart items:', cart.items);

                cart.items.forEach(item => {
                    // Check for _is_patch property (handle both string and boolean)
                    let isPatch = false;

                    if (item.properties) {
                        // Handle object properties
                        if (item.properties._is_patch === 'true' || item.properties._is_patch === true) {
                            isPatch = true;
                        }

                        // Handle array properties (rare but possible in some contexts)
                        if (Array.isArray(item.properties)) {
                            const patchProp = item.properties.find(p => p.name === '_is_patch' || p[0] === '_is_patch');
                            if (patchProp && (patchProp.value === 'true' || patchProp[1] === 'true')) {
                                isPatch = true;
                            }
                        }
                    }

                    // Fallback: Check handle or product_type for "patch"
                    if (!isPatch) {
                        if (item.handle && item.handle.toLowerCase().includes('patch')) isPatch = true;
                        if (item.product_type && item.product_type.toLowerCase().includes('patch')) isPatch = true;
                        // Check title but be careful not to flag shirts with "patch" in the name (e.g. "Shirt with Patch")
                        // Usually patches start with "Patch"
                        if (item.title && item.title.toLowerCase().startsWith('patch')) isPatch = true;
                    }

                    (`   - Item: ${item.title} | Qty: ${item.quantity} | Is Patch: ${isPatch} | Price: ${item.final_price}`);

                    if (!isPatch) {
                        // Count item even if it's free (price 0)
                        if (item.final_price === 0) {
                            ('   🎉 Found a FREE item, counting it towards progress!');
                        }
                        count += item.quantity;
                    }
                });

                ('📊 [Black Hype] Total Count (Shirts):', count);

                // Re-check elements (DOM might have changed)
                const fillEl = document.getElementById('progress-bar');
                const textTopEl = document.getElementById('progress-text-top');
                const textBottomEl = document.getElementById('progress-text-bottom');
                const markers = document.querySelectorAll('.shipping-bar__marker');

                if (!fillEl || !textTopEl || !textBottomEl || !markers.length) {
                    console.warn('⚠️ [Black Hype] Elements not found in DOM');
                    isUpdating = false;
                    return;
                }

                // Update progress bar
                const progress = Math.min(100, (count / MAX_TIER_NEEDED) * 100);
                (`📈 [Black Hype] Progress: ${progress}% (Count: ${count}/${MAX_TIER_NEEDED})`);

                // Force reflow/repaint
                fillEl.style.display = 'none';
                fillEl.offsetHeight; // trigger reflow
                fillEl.style.display = 'block';

                setTimeout(() => {
                    fillEl.style.width = progress + '%';
                }, 10);

                // Update markers
                let currentTier = null;
                let nextTier = TIERS[0];

                markers.forEach(marker => {
                    const needed = parseInt(marker.dataset.needed, 10);
                    marker.classList.remove('locked', 'reached', 'next');

                    const tierInfo = TIERS.find(t => t.needed === needed);
                    if (!tierInfo) return;

                    if (count >= needed) {
                        marker.classList.add('reached');
                        currentTier = tierInfo;

                        const currentTierIndex = TIERS.indexOf(tierInfo);
                        nextTier = TIERS[currentTierIndex + 1] || null;
                    } else {
                        marker.classList.add('locked');
                    }
                });

                // Add 'next' class to next marker
                if (nextTier) {
                    const nextMarker = document.querySelector(`.shipping-bar__marker[data-needed="${nextTier.needed}"]`);
                    if (nextMarker) nextMarker.classList.add('next');
                }

                // Update text
                const plural = (val) => (val > 1 ? 's' : '');
                const pluralPT = (val) => (val > 1 ? 's' : '');

                if (!nextTier && currentTier) {
                    // Reached max tier
                    if (currentTier.free) {
                        textTopEl.innerHTML = `Parabéns! Você ganhou ${currentTier.free} camisa${pluralPT(currentTier.free)} grátis!`;
                        textBottomEl.innerHTML = '';
                    } else if (currentTier.discount) {
                        textTopEl.innerHTML = `Parabéns! Você ganhou R$${currentTier.discount} de desconto!`;
                        textBottomEl.innerHTML = '';
                    }
                } else if (currentTier && nextTier) {
                    // Reached a tier, but there's a next one
                    const missing = nextTier.needed - count;

                    if (currentTier.free) {
                        textTopEl.innerHTML = `Você ganhou ${currentTier.free} camisa${pluralPT(currentTier.free)} grátis!`;
                    } else if (currentTier.discount) {
                        textTopEl.innerHTML = `Você ganhou R$${currentTier.discount} de desconto!`;
                    }

                    textBottomEl.innerHTML = `Adicione mais ${missing} camisa${pluralPT(missing)} para desbloquear: <strong>${nextTier.message}</strong>`;
                } else if (nextTier) {
                    // No tier reached yet
                    const missing = nextTier.needed - count;

                    if (count === 0) {
                        textTopEl.innerHTML = '';
                        textBottomEl.innerHTML = `Adicione ${missing} camisa${pluralPT(missing)} para ganhar: <strong>${nextTier.message}</strong>`;
                    } else {
                        textTopEl.innerHTML = '';
                        textBottomEl.innerHTML = `Adicione mais ${missing} camisa${pluralPT(missing)} para desbloquear: <strong>${nextTier.message}</strong>`;
                    }
                }

                isUpdating = false;
            })
            .catch(err => {
                console.error('Error updating progress bar:', err);
                isUpdating = false;
            });
    }

    /**
     * Debounced update function
     */
    function debouncedUpdate() {
        if (updateTimeout) clearTimeout(updateTimeout);
        updateTimeout = setTimeout(updateProgressBar, 100);
    }

    /**
     * Setup MutationObserver to watch for progress bar being added to DOM
     */
    function setupProgressBarObserver() {
        // Observe cart drawer for changes
        const cartDrawer = document.getElementById('Cart-Drawer');
        if (!cartDrawer) return;

        const observer = new MutationObserver(function (mutations) {
            mutations.forEach(function (mutation) {
                // Check if progress bar was added
                mutation.addedNodes.forEach(function (node) {
                    if (node.nodeType === 1) {
                        // Check if this node or its children contain the progress bar
                        if (node.id === 'progress-bar' ||
                            (node.querySelector && node.querySelector('#progress-bar'))) {
                            // Progress bar was just added, update immediately
                            setTimeout(updateProgressBar, 50);
                        }
                    }
                });
            });
        });

        observer.observe(cartDrawer, {
            childList: true,
            subtree: true
        });
    }

    /**
     * Initialize event listeners
     */
    function initListeners() {
        const events = [
            'cart:updated',
            'cart:refresh',
            'cart:item-added',
            'line-item:change:end',
            'cart-drawer:open',
            'pageshow'
        ];

        events.forEach(eventType => {
            document.addEventListener(eventType, debouncedUpdate);
        });

        // Also listen on documentElement
        document.documentElement.addEventListener('cart:updated', debouncedUpdate);
        document.documentElement.addEventListener('cart:refresh', debouncedUpdate);
    }

    /**
     * Intercept fetch calls to detect cart updates
     */
    function interceptCartFetch() {
        if (window._blackhypeProgressBarIntercepted) return;
        window._blackhypeProgressBarIntercepted = true;

        const originalFetch = window.fetch;
        window.fetch = function () {
            const [url] = arguments;
            const urlString = typeof url === 'string' ? url : (url && url.url ? url.url : '');

            if (urlString && (
                urlString.includes('/cart/add') ||
                urlString.includes('/cart/change') ||
                urlString.includes('/cart/update') ||
                urlString.includes('/cart.js')
            )) {
                return originalFetch.apply(this, arguments)
                    .then(response => {
                        // Update progress bar after cart operation
                        setTimeout(() => {
                            if (document.getElementById('progress-bar')) {
                                updateProgressBar();
                            }
                        }, 300);
                        return response;
                    });
            }

            return originalFetch.apply(this, arguments);
        };
    }

    /**
     * Initialize on DOM ready
     */
    function init() {
        initListeners();
        setupProgressBarObserver();
        interceptCartFetch();

        // Initial update if progress bar exists
        if (document.getElementById('progress-bar')) {
            updateProgressBar();
        }
    }

    // Initialize when DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }

})();
